<template>
    <div class="row">
        <div class="col-xs-6">
            <slot></slot>
        </div>

        <div class="col-xs-6 trivia-reorder">
            <div class="reorder-list">
                <draggable
                    v-model="orderedOptions"
                    :disabled="questionAnswered"
                >
                    <div
                        v-for="(option, index) in orderedOptions"
                        :key="option.id"
                        class="reorder-item"
                        :class="itemClass(option.id, index)"
                    >
                        <span class="reorder-handle">
                            <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="2" cy="2" r="2" fill="#A3B5C9"/>
                              <circle cx="8" cy="2" r="2" fill="#A3B5C9"/>
                              <circle cx="2" cy="8" r="2" fill="#A3B5C9"/>
                              <circle cx="8" cy="8" r="2" fill="#A3B5C9"/>
                              <circle cx="2" cy="14" r="2" fill="#A3B5C9"/>
                              <circle cx="8" cy="14" r="2" fill="#A3B5C9"/>
                            </svg>
                        </span>
                        <p class="reorder-text" v-html="option.text"></p>
                    </div>
                </draggable>
                <div v-if="questionAnswered" class="trivia-result-indicator">
                    <check v-if="isCorrect" class="svg-icon large"></check>
                    <incorrect v-else class="svg-icon large"></incorrect>
                </div>
            </div>
            <div class="reorder-submit">
                <button
                    v-if="!questionAnswered"
                    class="btn primary-btn"
                    @click="$emit('answer', orderedOptions.map(o => o.id))"
                >
                    {{ $t("CONTINUE") }}
                </button>
            </div>
        </div>
    </div>
</template>
<!----------------------------------------------------------------------------->
<script>
import draggable from "vuedraggable";
import Check from "Components/Svg/Check";
import Incorrect from "Components/Svg/Incorrect";

export default {
    name: "TriviaReorder",

    components: {draggable, Check, Incorrect},

    props: {
        question: {type: Object, required: true},
        questionAnswered: {type: Boolean, required: true},
        correct: {default: null},
    },

    data() {
        return {
            orderedOptions: [...this.question.options],
        };
    },

    computed: {
        isCorrect() {
            return this.orderedOptions.every((opt, i) => this.correct[i] === opt.id);
        },
    },

    methods: {
        itemClass(optionId, index) {
            if (!this.questionAnswered) return {};
            return {
                "correct-hit": this.correct[index] === optionId,
                incorrect: this.correct[index] !== optionId,
            };
        },
    },
};
</script>
<!----------------------------------------------------------------------------->
<style lang="scss" type="text/scss"></style>
